export enum DynamicPropertyEvent {
    CHANGED = 'changed',
}
